import {CLASIFICACION_FILTER_INCIDENT_LINKED} from 'src/modules/shared/clasificacionIncidentLinked';
import Errors from 'src/modules/shared/error/errors';
import selectors from 'src/modules/tarea/list/tareaListIncidentSelectors';
import TareaService from 'src/modules/tarea/tareaService';

const prefix = 'TAREA_LIST_INCIDENT';

const tareaListIncidentActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,
  SET_HAS_FILTER: `${prefix}_SET_HAS_FILTER`,
  SET_PAYLOAD: `${prefix}_SET_PAYLOAD`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  doClearAllSelected() {
    return {
      type: tareaListIncidentActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: tareaListIncidentActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: tareaListIncidentActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset:
    (emptyValues = {}) =>
    async (dispatch) => {
      dispatch({
        type: tareaListIncidentActions.RESETED,
        payload: emptyValues,
      });
      dispatch(tareaListIncidentActions.doFetchCurrentFilter());
    },

  doChangePagination: (pagination) => async (dispatch) => {
    dispatch({
      type: tareaListIncidentActions.PAGINATION_CHANGED,
      payload: pagination,
    });
    dispatch(tareaListIncidentActions.doFetchCurrentFilter());
  },

  doChangeSort: (sorter) => async (dispatch) => {
    dispatch({
      type: tareaListIncidentActions.SORTER_CHANGED,
      payload: sorter,
    });
    dispatch(tareaListIncidentActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (dispatch, getState) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(tareaListIncidentActions.doFetch(filter, rawFilter, true));
  },

  setPayload: (payload) => ({
    type: tareaListIncidentActions.SET_PAYLOAD,
    payload,
  }),

  setHasFilter:
    (filter, atLeastHast: string[] = []) =>
    async (dispatch) => {
      try {
        const keysThatAreArrays = [
          'comienzoRange',
          'fechaActivacionRange',
          'fechaLimiteRange',
          'fechaProgramacionRange',
          'finRange',
        ];
        const hasFilter = !!Object.keys(filter).find((key) => {
          if (atLeastHast.length && !atLeastHast.includes(key)) return false;
          if (key === 'fechaProgramacionRange') {
            const hasBoth =
              filter['fechaProgramacionRange']?.length === 2 &&
              filter['fechaProgramacionRange'][0] &&
              filter['fechaProgramacionRange'][1];
            return hasBoth;
          }
          if (keysThatAreArrays.includes(key)) {
            return filter[key].length && filter[key][0];
          }
          return filter[key];
        });
        dispatch({
          type: tareaListIncidentActions.SET_HAS_FILTER,
          payload: {hasFilter, filter},
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: tareaListIncidentActions.FETCH_ERROR,
        });
      }
    },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        const baseFilter = {...(filter || {})};
        if (
          baseFilter.clasificacion == null ||
          baseFilter.clasificacion === ''
        ) {
          baseFilter.clasificacion = [...CLASIFICACION_FILTER_INCIDENT_LINKED];
        }
        dispatch({
          type: tareaListIncidentActions.FETCH_STARTED,
          payload: {filter: baseFilter, rawFilter: rawFilter || baseFilter, keepPagination},
        });

        const response = await TareaService.list(
          baseFilter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: tareaListIncidentActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: tareaListIncidentActions.FETCH_ERROR,
        });
      }
    },
};

export default tareaListIncidentActions;
